import { openPanel } from './pdp-store_selection-finder';

export function init() {
  cube.$('.buying-zone').addEventListener('click', e => {
    const isToggler = e.target.classList.contains('js-open-store-selector');
    const isTogglerChild = !!e.target.closest('.js-open-store-selector');

    if (isToggler || isTogglerChild) {
      if (
        cube.$('.buying-zone .sizes__wrapper--visible') &&
        !cube.$('.buying-zone .sizes__wrapper--visible .sizes__size--selected') &&
        !cube.$('.buying-zone .sizes__wrapper--visible').dataset.usize
      )
        window.displayError(
          window.Messages('pdm.pleaseSelectSize'),
          window.Consts.MAIN_ERROR
        );
      else openPanel();
    }
  });
}



// WEBPACK FOOTER //
// ./src/catalog/product-details/store_stock.entry.js